import { advancedColors } from '../../theme'

export const chatComposerInputSx = (accent: string, inputHeight = 44) => ({
  mt: 0,
  minWidth: 0,
  '& .MuiOutlinedInput-root': {
    borderRadius: '12px',
    minHeight: inputHeight,
    padding: '10px 12px',
    alignItems: 'flex-start',
    color: advancedColors.inkMuted,
    '& .MuiOutlinedInput-notchedOutline': { borderColor: advancedColors.line },
    '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: accent },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: accent },
  },
  '& .MuiInputBase-inputMultiline': {
    padding: 0,
    lineHeight: 1.5,
    overflowWrap: 'anywhere',
  },
})
